module.exports = __webpack_public_path__ + "img/icon_hw.47065ff2.png";